import React, { Component } from "react";
//Alert dialog
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { CircularProgress, TextField } from "@material-ui/core";
import { validateEmail } from "../CheckoutProcess/FirstStep";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import instance from "../../store/actions/instance";

class NotifyMeDialog extends Component {
  state = {
    email: this.props.customer?.email,
    emailError: false,

    loading: false,
  };

  notify = async () => {
    try {
      this.setState({ loading: true });
      await instance.post("notify_out_of_stock_product/", {
        email: this.state.email,
        productID: this.props.productID,
        branchID: this.props.branch?.branch,
      });
      this.props.onClose("success");
    } catch (e) {
      this.props.onClose("error");
    }
  };
  render() {
    const { language } = this.props;
    const inputLabelStyle = {
      transformOrigin: language == "english" ? "top left" : "top right",
      right: language == "arabic" ? 0 : "unset",
      left: language == "english" ? 0 : "unset",
    };
    const { email, emailError, loading } = this.state;
    return (
      <Dialog
        open={this.props.dialogOpen}
        onClose={(e) => this.props.onClose(null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: language === "english" ? "left" : "right" }}
        >
          {language === "arabic"
            ? "ادخل بريدك الالكتروني ليتم تنبيهك عند توفر المنتج"
            : "Enter your email to be notified when the product is back in stock"}
        </DialogTitle>
        <DialogContent>
          <TextField
            id="standard-basic"
            error={emailError}
            fullWidth
            color={"#0099cc"}
            onChange={(e) => {
              this.setState({ email: e.target.value, emailError: false });
            }}
            name="email"
            type="email"
            placeholder={language === "english" ? "Email" : "البريد الإلكتروني"}
            value={email}
            InputLabelProps={{
              style: inputLabelStyle,
              dir: language == "english" ? "ltr" : "rtl",
            }}
            InputProps={{
              dir: language == "english" ? "ltr" : "rtl",
            }}
            helperText={
              emailError
                ? language == "english"
                  ? "Please enter your email"
                  : "الرجاء ادخال الايميل"
                : ""
            }
            FormHelperTextProps={{
              style: {
                textAlign: language == "arabic" && "right",
                marginRight: language == "arabic" && 5,
              },
            }}
          />
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: language == "english" ? "flex-end" : "flex-start",
          }}
        >
          <Button
            onClick={(e) => {
              if (!validateEmail(email)) {
                this.setState({ emailError: true });
              } else {
                this.notify();
              }
            }}
            color="primary"
            disabled={!this.state.email || emailError}
          >
            {loading ? (
              <CircularProgress color="primary" size={30} />
            ) : language === "arabic" ? (
              "اتمام"
            ) : (
              "Notify Me!"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
    customer: state.customers.customerContact,
    branch: state.branch,
  };
};

export default connect(mapStateToProps)(NotifyMeDialog);
